import * as React from "react";

import "./HorizontalBarGraph.scss";

interface Props {
  data: HorizontalBarGraphData[];
  showTotals?: boolean;
}
export interface HorizontalBarGraphDataRow {
  value: number;
  color: string;
}
export interface HorizontalBarGraphData {
  title: string;
  rows: HorizontalBarGraphDataRow[];
  total?: number;
}
function getHighestValue(data: HorizontalBarGraphData[]): number {
  var highest = 0;

  if (data && data.length) {
    for (let i = 0; i < data.length; i++) {
      const element = data[i];
      if (data[i].rows && data[i].rows.length) {
        for (let j = 0; j < data[i].rows.length; j++) {
          if (data[i].rows[j].value > highest) {
            highest = data[i].rows[j].value;
          }
        }
      }
    }
  }

  return highest;
}
function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export class HorizontalBarGraph extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  renderBars(row: HorizontalBarGraphDataRow, highestValue: number, key: string) {
    if (row.value > 0 && highestValue) {
      const widthPercent = Math.round((row.value / highestValue) * 100);
      return (
        <div className="graphBarTrack" key={key}>
          <div className="graphBarValue" style={{ width: widthPercent + "%", background: row.color }} />
        </div>
      );
    }
    return (
      <div key={key} className="graphBarTrack">
        {" "}
      </div>
    );
  }

  render() {
    const { data, showTotals } = this.props;
    const highestValue = getHighestValue(data);
    const items = data.map((row) => {
      const key = "row" + row.title;
      const bars = row.rows.map((bar, index) => this.renderBars(bar, highestValue, key + index));
      const total = showTotals && row.total ? <td className="totalRow">{row.total.toLocaleString()}</td> : <td className="totalRow">0</td>;
      return (
        <tr key={key}>
          <td className="valueRow">
            <div className="rowName">{row.title}</div>
            {bars}
          </td>
          {total}
        </tr>
      );
    });
    return (
      <table className="HorizontalBarGraph">
        <tbody>{items}</tbody>
      </table>
    );
  }
}
